import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
var AlertModalService = /** @class */ (function () {
    function AlertModalService(modalService) {
        this.modalService = modalService;
    }
    AlertModalService.prototype.open = function (title) {
        var modalRef = this.modalService.open(AlertModalComponent, { size: 'sm', backdrop: 'static', keyboard: false });
        var instance = modalRef.componentInstance;
        instance.title = title;
        return instance;
    };
    AlertModalService.prototype.openWithMessageAndTitle = function (title, message) {
        var modalRef = this.modalService.open(AlertModalComponent, { size: 'sm', backdrop: 'static', keyboard: false });
        var instance = modalRef.componentInstance;
        instance.title = title;
        instance.message = message;
        return instance;
    };
    AlertModalService.prototype.openWithMessageAndTitleAndShowOkButtonAndReturnPromise = function (title, message) {
        var modalRef = this.modalService.open(AlertModalComponent, { size: 'sm', backdrop: 'static', keyboard: false });
        var instance = modalRef.componentInstance;
        instance.title = title;
        instance.message = message;
        instance.showOkButton = true;
        return modalRef.result;
    };
    return AlertModalService;
}());
export { AlertModalService };
var AlertModalComponent = /** @class */ (function () {
    function AlertModalComponent(modal) {
        this.modal = modal;
        this.showOkButton = false;
        this.enableClosingActions = true;
    }
    Object.defineProperty(AlertModalComponent.prototype, "linkTitleText", {
        get: function () {
            return this.linkTitle ? this.linkTitle : this.link;
        },
        enumerable: true,
        configurable: true
    });
    AlertModalComponent.prototype.cancel = function () {
        this.modal.dismiss('cancel');
    };
    AlertModalComponent.prototype.confirm = function () {
        this.modal.close();
    };
    AlertModalComponent.prototype.close = function () {
        this.modal.close();
    };
    return AlertModalComponent;
}());
export { AlertModalComponent };
